export const variantInOpenedListLocale = $localize`:Config Strip|Variant in opened list message@@variantInOpenedListMessage:This product is in the list`;
